import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {
  private config: any;

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    try {
      this.config = await firstValueFrom(
        this.http.get(`assets/${environment.appConfig}`)
      );
    } catch (error) {
      console.error('Error loading configuration:', error);
      this.config = {};
    }
  }

  get baseUrl(): string {
    return this.config?.remoteServiceBaseUrl;
  }

  get(path: string): any {
    if (!this.config) {
      return undefined;
    }
    return path.split('.').reduce((config: any, key: string) => {
      return config && config[key];
    }, this.config);
  }
}
